/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import { CommonUtils } from '../../../../utils/CommonUtils'
import { IImmunizationHistory } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface IImmunizationEventProps {
	data: IImmunizationHistory
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IImmunizationEventState {}

export class ImmunizationEventComponent extends React.Component<IImmunizationEventProps, IImmunizationEventState> {
	render(): JSX.Element {
		return (
			<tr>
				<td className="bottom-border-td">
					{!CommonUtils.isUndefinedOrNull(this.props.data.code) ? (
						<span>
							Code <strong> {this.props.data.code} </strong> Date:
						</span>
					) : (
						'Date:'
					)}
				</td>
				<td className="bottom-border-td">{CommonUtils.toDisplayDate(this.props.data.immunizationDate)}</td>
				<td className="bottom-border-td">Rendering NPI:</td>
				<td className="bottom-border-td">{this.props.data.renderingNpi}</td>
			</tr>
		)
	}
}
